export const environment = {
  production: true,
  baseUrl: 'https://license-api.vivotek.com' //https://license-api.vivotek.com  http://localhost:56303/
};
